import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Button, FormArray, FormInput, useFormContext } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { useFieldArray } from "react-hook-form";
import { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";

import VideoPreview from "./VideoPreview";
import { TContentForm } from "../../ContentSchema";

const translation_path = "components.content.";

interface IContentVideoModalProps {
  mainIndex: number;
  onClose: () => void;
  open: boolean;
}

const ContentVideoModal: React.FC<IContentVideoModalProps> = ({
  mainIndex,
  onClose,
  open,
}) => {
  const { control, trigger, setValue } = useFormContext<TContentForm>();
  const { t } = useTranslation();

  const contentsFieldArray = useFieldArray({
    control,
    name: `contents.${mainIndex}.contentVideos`,
  });

  const onClickSaveHandler = async () => {
    const response = await trigger(`contents.${mainIndex}.contentVideos`);
    if (response) {
      onClose();
    }
  };

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">{t(translation_path + "videos")}</Typography>
          <IconButton aria-label="close" size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <FormArray
          title=""
          addButtonLabel={
            t(translation_path + "add_new_video") || "Add new video"
          }
          name="contentVideos"
          showAddButton={contentsFieldArray.fields.length < 5}
          formArray={contentsFieldArray}
          appendValue={{ link: "", displayOrder: 0, name: "Video" }}
          fieldsObject={(index) => {
            const linkPath = `contents.${mainIndex}.contentVideos.${index}.link`;
            const orderPath = `contents.${mainIndex}.contentVideos.${index}.displayOrder`;
            return (
              <Grid
                item
                xs={12}
                sx={{
                  padding: 2,
                  borderRadius: 1,
                }}
              >
                <Stack gap={2}>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <FormInput
                      size="small"
                      onChange={(e) => {
                        const raw = e.target.value;
                        const num = raw === "" ? 0 : Number(raw);
                        setValue(orderPath as any, num, {
                          shouldValidate: false,
                          shouldDirty: true,
                        });
                      }}
                      onBlur={() =>
                        trigger(
                          `contents.${mainIndex}.contentVideos.${index}.displayOrder`
                        )
                      }
                      name={orderPath}
                      label={t(translation_path + "display_order")}
                      type="number"
                      sx={{ width: 140 }}
                    />
                    <FormInput
                      size="small"
                      onBlur={() =>
                        trigger(
                          `contents.${mainIndex}.contentVideos.${index}.link`
                        )
                      }
                      name={linkPath}
                      label={t(translation_path + "link")}
                      fullWidth
                      helperText={t(translation_path + "link_helper")}
                    />
                  </Stack>

                  <VideoPreview
                    index={index}
                    mainIndex={mainIndex}
                    control={control}
                  />
                </Stack>
              </Grid>
            );
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={onClickSaveHandler}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(ContentVideoModal);
